// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Translation
import { FormattedMessage, useIntl } from 'react-intl';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './SocialShareModal.css';
import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap';


// Actions
import { closeSocialShareModal } from '../../../actions/modalActions';

import { formatURL } from '../../../helpers/formatURL';

import messages from '../../../locale/messages';

//Images
import facebookIcon from '/public/SiteIcons/shareFacebook.svg';
import twitterIcon from '/public/SiteIcons/shareTwitter.svg';
import emailIcon from '/public/SiteIcons/shareEmail.svg';
import copyIcon from '/public/SiteIcons/shareLink.svg';

import { url } from '../../../config';

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";

const SocialShareModal = ({ title, city, state, country, listId }) => {

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const socialShareModal = useSelector(state => state.modalStatus.isSocialShareModal);
  const siteName = useSelector(state => state.siteSettings.data.siteName);

  const [socialShareModalStatus, setSocialShareModalStatus] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setSocialShareModalStatus(socialShareModal);
  }, [socialShareModal])


  const copyText = async () => {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000)
  }

  const shareUrl = url + '/rooms/' + formatURL(title) + '-' + listId;
  let previewText = `Check out this listing on ${siteName}!`;
  let bodyText = `Share this place with friends and family!
    Check out ${title} in ${city}, ${state}, ${country}" on ${siteName}.`;

  return (
    <div>
      <Modal show={socialShareModalStatus} animation={false} onHide={() => dispatch(closeSocialShareModal())} dialogClassName={cx(s.signupModalContainer, 'signupModal', 'sharesocialModal')} >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body bsClass={s.signupModalBody}>
          <div className={s.paddingbottom24}>
            <div className={s.share}>
              <FormattedMessage {...messages.shareLabel} />
            </div>
            <div className={s.content}>
              <FormattedMessage {...messages.socialShareDesc} /> <FormattedMessage {...messages.checkOutShare} /> <span>{title} <FormattedMessage {...messages.inLabel} /> {city}, {state}, {country} <FormattedMessage {...messages.onLabel} />{' '}{siteName}</span>
            </div>
          </div>
          <ListGroup className={cx('sharingsocial', 'shareSocialLink')}>
            <div className={s.mainBorder}>
              <ListGroupItem tag="a" href={shareUrl} className={s.borderradiusNone}>
                <FacebookShareButton
                  url={shareUrl}
                >
                  <img src={facebookIcon} className={cx(s.socialIcons, 'socialIconsRtl')} />
                  <FormattedMessage {...messages.facebook} />
                </FacebookShareButton>
              </ListGroupItem>
            </div>
            <div className={s.mainBorder}>
              <ListGroupItem tag="a" href={shareUrl}>
                <TwitterShareButton
                  url={shareUrl}
                  className={s.displayIcon}>
                  <img src={twitterIcon} className={cx(s.socialIcons, 'socialIconsRtl')} />
                  <FormattedMessage {...messages.twitter} />
                </TwitterShareButton>
              </ListGroupItem>
            </div>
            <div className={s.mainBorder}>
              <ListGroupItem tag="a" href={shareUrl}>
                <EmailShareButton
                  url={shareUrl}
                  subject={previewText}
                  body={bodyText}
                  className={s.displayIcon}>
                  <img src={emailIcon} className={cx(s.socialIcons, 'socialIconsRtl')} />
                  <FormattedMessage {...messages.emailLabel} />
                </EmailShareButton>
              </ListGroupItem>
            </div>
            <div>
              <ListGroupItem>
                <CopyToClipboard
                  text={shareUrl}
                  onCopy={() => copyText()}
                >
                  <div>
                    <img src={copyIcon} className={cx(s.socialIcons, 'socialIconsRtl')} />
                    <span>{copied ? formatMessage(messages.linkCopiedLabel) : formatMessage(messages.copyLinkLabel)}</span>
                  </div>
                </CopyToClipboard>
              </ListGroupItem>
            </div>
          </ListGroup>
        </Modal.Body>
      </Modal>
    </div>
  );
}

SocialShareModal.propTypes = {
  socialShareModal: PropTypes.bool,
  formatMessage: PropTypes.func,
};

export default withStyles(s)(SocialShareModal);